import React from 'react';
import { NavLink } from "react-router-dom";

const DiscontinuedNotice = ({ productName }) => {
  const title = productName ? `${productName} has been discontinued` : 'This product has been discontinued';

  return (
    <div className="fullwidth light discontinued-section">
      <div className="row">
        <div className="twelve columns">
          <div className="panel bordered discontinued-notice">
            <h3>{title}</h3>
            <p>
              Please take a look at our <NavLink to="/en/dedicated-servers-switzerland">Dedicated Servers</NavLink> or <NavLink to="/en/confidential-servers-switzerland">AMD SEV Confidential Computing Servers</NavLink>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscontinuedNotice;
